module.exports = __webpack_public_path__ + "static/img/new-tag-kua.1162c7cf.png";